"use strict";
/*
 * Created on 05 24 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../../core/utils/index");

var ReleaseWorkflowType_1 = require("../../../release/model/ReleaseWorkflowType");

var SelloutReleaseType_1 = require("../../../release/model/sellout/SelloutReleaseType");

var SelloutImpactReportDetailRowReleaseDTO_1 = require("../model/SelloutImpactReportDetailRowReleaseDTO");

var SelloutImpactReportDetailRowReleaseDTOConverter_1 = require("./SelloutImpactReportDetailRowReleaseDTOConverter");

var SelloutImpactReportDetailValuesDTOConverter_1 = require("./SelloutImpactReportDetailValuesDTOConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailRowReleaseDTOConverterImpl =
/*#__PURE__*/
function (_SelloutImpactReportD) {
  _inherits(SelloutImpactReportDetailRowReleaseDTOConverterImpl, _SelloutImpactReportD);

  function SelloutImpactReportDetailRowReleaseDTOConverterImpl(valuesConverter) {
    var _this;

    _classCallCheck(this, SelloutImpactReportDetailRowReleaseDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailRowReleaseDTOConverterImpl).call(this));
    _this.valuesConverter = valuesConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutImpactReportDetailRowReleaseDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutImpactReportDetailRowReleaseDTO_1.SelloutImpactReportDetailRowReleaseDTO(conversions.asObject(source, 'releaseId', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'releaseName', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asEnum(source.workflowType, ReleaseWorkflowType_1.ReleaseWorkflowType), conversions.asEnum(source.selloutReleaseType, SelloutReleaseType_1.SelloutReleaseType), conversions.asObject(source, 'values', function (v) {
        return _this2.valuesConverter.toObject(v, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        releaseId: source.releaseId,
        releaseName: source.releaseName,
        workflowType: source.workflowType,
        selloutReleaseType: source.selloutReleaseType,
        values: this.valuesConverter.toDocument(source.values, conversions)
      };
    }
  }]);

  return SelloutImpactReportDetailRowReleaseDTOConverterImpl;
}(SelloutImpactReportDetailRowReleaseDTOConverter_1.SelloutImpactReportDetailRowReleaseDTOConverter);

SelloutImpactReportDetailRowReleaseDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutImpactReportDetailValuesDTOConverter_1.SelloutImpactReportDetailValuesDTOConverter])], SelloutImpactReportDetailRowReleaseDTOConverterImpl);
exports.SelloutImpactReportDetailRowReleaseDTOConverterImpl = SelloutImpactReportDetailRowReleaseDTOConverterImpl;